import { Injectable, OnDestroy } from "@angular/core";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { ProcessBulkPayload, SaveTracking } from './../models/common.model';
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CommonService implements OnDestroy{
  private url = "api/common";
  account: string;
  private destroy$ = new Subject<void>();
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  constructor(private http: HttpClient) {}

  public DataQueue(data: any) {
    return this.http.post(`/${this.url}/dataqueue`, data, this.options);
  }
  public AddToShipment(data: any) {
    return this.http.post(`/${this.url}/addtoshipment`, data, this.options);
  }

  public Getcategorylist(data: any) {
    return this.http.post(`/${this.url}/getcategorylist`, data, this.options);
  }

  public UpdateShipment(arg1: string, arg2: string) {
    const data = JSON.stringify({
      type: "Update Shipment QTY",
      arg1,
      arg2,
    });
    return this.http.post(`/${this.url}/updateshipment`, data, this.options);
  }

  public UpdateBoxContent(arg1: string, arg2: string) {
    const data = JSON.stringify({
      type: "Upload box content",
      arg1,
      arg2,
    });
    return this.http.post(`/${this.url}/updateboxcontent`, data, this.options);
  }

  public CloseShipment(arg1: string, arg2: string, arg3: string) {
    const data = JSON.stringify({
      type: "Submit Shipment",
      arg1,
      arg2,
      arg3,
    });
    return this.http.post(`/${this.url}/closeshipment`, data, this.options);
  }

  public GetQueueProcessingUpdates(id) {
    return this.http.get(
      `/${this.url}/GetQueueProcessingUpdates/${id}`,
      this.options
    );
  }

  GetBulkDefinition(payload) {
    return this.http.post(
      `/${this.url}/GetBulkDefinition`,payload,      
      this.options
    );
  }

  ProcessBulk(data: ProcessBulkPayload) {
    return this.http.post(
      `/${this.url}/ProcessBulk`,
      data,
      this.options
    );
  }

  UploadAmazonBox(data){
    return this.http.post(
      `/${this.url}/UploadAmazonBox`,
      data,
      this.options
    );
  }

  SaveEndpointTracking(data: SaveTracking) {
    return this.http.post(
      `/${this.url}/SaveEndpointTracking`,
      data,
      this.options
    );
  }

  GetApiJsonAll() {
    return this.http.get(`${this.url}/GetApiJsonAll`, this.options);
  }
  
  saveApiJson(data){
    return this.http.post(`/${this.url}/SaveApiJson`, data, this.options);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
